export default __webpack_public_path__ + "static/media/NewUserIcon.0d5ab2b3.svg";